import { apiClient } from './client';
// User roles API functions
export const userRolesApi = {
    /**
     * Get all user role assignments for a specific company
     */
    getUserRolesByCompany: (clientCompanyId) => apiClient.get(`/api/UserCompanyRoles/Company/${clientCompanyId}`),
    /**
     * Update user company role set
     */
    updateUserCompanyRoleSet: (updateDto) => apiClient.put('/api/UserCompanyRoles/Update', updateDto),
    /**
     * Create a new user with initial role assignments
     */
    createUser: (createDto) => apiClient.post('/api/Users/CreateUser', createDto),
    /**
     * Soft delete a user from a client company
     */
    deleteUser: (userProfileId, clientCompanyId) => apiClient.delete(`/api/Users/${userProfileId}/ClientCompany/${clientCompanyId}`),
};
